import { first } from "lodash";
import {
  V2ParameterValueSet_ValueType,
  V2ParameterValueType,
} from "../etc/parameter-types";
import {
  ParameterInstanceContainerType,
  StorageItemNameInstanceDescriptor,
  V2FieldValueDisplayType,
} from "../etc/types";
import { ParameterInstanceCreateContainer } from "../interfaces/entity-settings/parameters/parameters";
import {
  ParameterInstance,
  ParameterInstanceContainer,
  ParameterInstanceContainerFilled,
  ParameterListTitle,
  ValueOfSetContainer,
} from "../interfaces/parameters/parameter-models";
import { StorageItemNameInstance, StorageItemNameInstanceRecord, StorageItemNameInstanceSimple, StorageItemNameInstanceTitle } from "../interfaces/storage/storage-models";
import { findRecursive, foreachRecursive, mapRecursive } from "./recursive";

export function isInstanceContainerEmpty(val: ParameterInstanceContainer, checkLists: boolean = false) {
  let allEmpty = true;
  foreachRecursive(
    function a(element: any, el_to_find: any): any | undefined {
      if (!element) return;

      const insts = (element as ParameterInstanceContainer).Instance;
      const ttl = (element as ParameterInstanceContainer).ListTitle;
      // validation
      if (
        (element as ParameterInstanceContainer).Type ===
          ParameterInstanceContainerType.SingleInstance &&
        insts !== null
      ) {
        if (
          insts.ValueType !== V2ParameterValueType.Record &&
          ((insts.BoolValue != null && insts.BoolValue != undefined) ||
            (insts.SelectedValue && (insts.SelectedValue.Id || insts.SelectedValue.Name)) ||
            insts.DateValue ||
            (insts.NumberValue != null && insts.NumberValue != undefined) ||
            insts.StringValue)
        ) {
          allEmpty = false;
        }
      } else if (!checkLists && (element as ParameterInstanceContainer).Type ===
      ParameterInstanceContainerType.List && ttl !== null) {
        for (let i = 0; i < ttl.Instances.length; i++) {
          const insts_l = ttl.Instances[i]
          if (
            insts_l.ValueType !== V2ParameterValueType.Record &&
            ((insts_l.BoolValue != null && insts_l.BoolValue != undefined) ||
              (insts_l.SelectedValue && (insts_l.SelectedValue.Id || insts_l.SelectedValue.Name)) ||
              insts_l.DateValue ||
              (insts_l.NumberValue != null && insts_l.NumberValue != undefined) ||
              insts_l.StringValue)
          ) {
            allEmpty = false;
          }

          if (
            insts_l &&
            insts_l.ValueType === V2ParameterValueType.Record &&
            insts_l.RecordFields
          ) {
            foreachRecursive(a, undefined, insts_l.RecordFields);
          }
        }
      } else {
        console.log("no lists in filter!");
        // res.push({
        //     filterDescriptor: val.Descriptor,
        //     filterCategory: val.Category,
        //     conditionIndex: index,
        //     errorText: 'no lists in filter!'
        // })
      }

      // if record then fields validation
      if (
        insts &&
        insts.ValueType === V2ParameterValueType.Record &&
        insts.RecordFields
      ) {
        foreachRecursive(a, undefined, insts.RecordFields);
      }
    },
    undefined,
    [val]
  );
  return allEmpty
}

export function hasInstanceContainerStructureChanged(val_m: ParameterInstanceContainer[], val_old_m: ParameterInstanceContainer[]) {
  const instanceDifferent = function(val: ParameterInstanceContainer, val_old: ParameterInstanceContainer): boolean {
    if (!val || !val_old) { return true; }

    if (val.Type !== val_old.Type) {
      return true
    } else if (val.Type === ParameterInstanceContainerType.SingleInstance) {
      if (val.Instance?.RecordFields.length !== val_old.Instance?.RecordFields.length ||
        val.Instance?.Id !== val_old.Instance?.Id
      ) {
        return true
      } else if (val.Instance?.RecordFields && val_old.Instance?.RecordFields) {
        for (let rec = 0; rec < val.Instance?.RecordFields.length; rec++) {
          if (instanceDifferent(val.Instance?.RecordFields[rec], val_old.Instance?.RecordFields[rec])) {
            return true
          }
        }
      }
    } else if (val.Type === ParameterInstanceContainerType.List) {
      if (val.ListTitle?.Instances.length !== val_old.ListTitle?.Instances.length) {
        return true
      } else if (val.ListTitle?.Instances && val_old.ListTitle?.Instances) {
        for (let list_i = 0; list_i < val.ListTitle?.Instances.length; list_i++) {
          if (val.ListTitle?.Instances[list_i]?.RecordFields.length !== val_old.ListTitle?.Instances[list_i]?.RecordFields.length ||
            val.ListTitle?.Instances[list_i]?.Id !== val_old.ListTitle?.Instances[list_i]?.Id
          ) {
            return true
          } else if (val.ListTitle?.Instances[list_i]?.RecordFields && val_old.ListTitle?.Instances[list_i]?.RecordFields) {
            for (let rec = 0; rec < val.ListTitle?.Instances[list_i]?.RecordFields.length; rec++) {
              if (instanceDifferent(val.ListTitle?.Instances[list_i]?.RecordFields[rec], val_old.ListTitle?.Instances[list_i]?.RecordFields[rec])) {
                return true
              }
            }
          }
        }
      }
    }
    return false;
  }

  if (!val_m || !val_old_m) {
    return true;
  }

  if (val_m.length !== val_old_m.length) {
    return true;
  }

  for (let inst = 0; inst < val_m.length; inst++) {
    if (instanceDifferent(val_m[inst], val_old_m[inst])) {
      return true;
    }
  }
  
  return false;
}

export function instanceToFilled(
  insts: ParameterInstance
): ParameterInstanceContainerFilled {
  return {
    TemplateId: insts.TemplateId,
    // TODO: add the ValueType logic here
    StringValue: insts.StringValue,
    NumberValue: insts.NumberValue,
    BoolValue: insts.BoolValue,
    ValueOfSet:
      insts.ValueType === V2ParameterValueType.ValueSet &&
      insts.SelectedValue &&
      insts.SelectedValue.Id
        ? insts.SelectedValue.Id
        : null,
    NewCreatedValue:
      insts.ValueType === V2ParameterValueType.ValueSet &&
      insts.SelectedValue &&
      insts.SelectedValue.Name &&
      !insts.SelectedValue?.Id
        ? ({
            // Идентификатор значения. Для нового значения не устанавливать.
            Id: 0,
            // Название значения типа "Строка".
            NameString:
              insts.ValueSet?.ValueType === V2ParameterValueSet_ValueType.String
                ? insts.SelectedValue.Name
                : null,
            // Название значения типа "Целый / Дробный".
            NameNumber:
              insts.ValueSet?.ValueType ===
                V2ParameterValueSet_ValueType.Decimal ||
              insts.ValueSet?.ValueType === V2ParameterValueSet_ValueType.Int
                ? parseInt(insts.SelectedValue.Name)
                : null,
            // Название значения типа "Дата".
            NameDate:
              insts.ValueSet?.ValueType === V2ParameterValueSet_ValueType.Date
                ? new Date(insts.SelectedValue.Name)
                : null,
          } as ValueOfSetContainer)
        : null, //для открытых множеств, если было создано и выбрано новое значение.
    DateValue: insts.DateValue, //значение типа "Дата"
  } as ParameterInstanceContainerFilled;
}

// for filter put everything into StringFalue
export function instanceToFilledSimple(
  insts: ParameterInstance
): ParameterInstanceContainerFilled {
  return {
    TemplateId: insts.TemplateId,
    // TODO: add the ValueType logic here
    StringValue:
      insts.StringValue ||
      (insts.ValueType === V2ParameterValueType.ValueSet &&
      insts.SelectedValue?.Name &&
      !insts.SelectedValue?.Id
        ? insts.SelectedValue.Name
        : ""),
    NumberValue: insts.NumberValue,
    BoolValue: insts.BoolValue,
    ValueOfSet:
      insts.ValueType === V2ParameterValueType.ValueSet &&
      insts.SelectedValue &&
      insts.SelectedValue.Id
        ? insts.SelectedValue.Id
        : null,
    NewCreatedValue: undefined, //для открытых множеств, если было создано и выбрано новое значение.
    DateValue: insts.DateValue, //значение типа "Дата"
  } as ParameterInstanceContainerFilled;
}

// this one is for filters
export function mapFilledContainerFromInstance(
  instance_container: ParameterInstanceContainer[],
  forFilter: boolean = false
): ParameterInstanceContainerFilled[] {
  const res = mapRecursive(
    function a(el: ParameterInstanceContainer, parent: any) {
      let new_el;
      const ttl = el.ListTitle;
      const insts = el.Instance;
      if (el.Type === ParameterInstanceContainerType.SingleInstance && insts) {
        new_el = forFilter
          ? instanceToFilledSimple(insts)
          : instanceToFilled(insts);
        new_el.RecordFields =
          insts.ValueType === V2ParameterValueType.Record && insts.RecordFields
            ? mapRecursive(a, el, insts.RecordFields)
            : [];
      } else if (el.Type === ParameterInstanceContainerType.List && ttl) {
        return ttl.Instances.map((i) => {
          const new_el = forFilter
            ? instanceToFilledSimple(i)
            : instanceToFilled(i);
          new_el.RecordFields =
            i.ValueType === V2ParameterValueType.Record && i.RecordFields
              ? mapRecursive(a, el, i.RecordFields)
              : [];
          return new_el;
        });
      }
      return new_el;
    },
    undefined,
    instance_container
  );

  return res;
}

export function instanceForFilterFromInstance(
  instance_container: ParameterInstanceContainer[]
): ParameterInstanceContainer[] {
    const res = instance_container;
    foreachRecursive(
      function a(
        element: ParameterInstanceContainer,
        el_to_find: any
      ): any | undefined {
        if (!element) return;

        if (element.Type === ParameterInstanceContainerType.SingleInstance && element.Instance) {

          element.Instance.StringValue = 
            element.Instance.StringValue ||
            (element.Instance.ValueType === V2ParameterValueType.ValueSet &&
            element.Instance.SelectedValue?.Name &&
            !element.Instance.SelectedValue?.Id
              ? element.Instance.SelectedValue.Name
              : '');

          if (!element.Instance.SelectedValue?.Id) {
            element.Instance.SelectedValue = null;
          }

          // for filters section only!
          element.Instance.Id = element.Instance.TemplateId;

          if (element.Instance.ValueType === V2ParameterValueType.Record) {
            foreachRecursive(a, el_to_find, element.Instance.RecordFields);
          }
        } else if (element.Type === ParameterInstanceContainerType.List && element.ListTitle) {
            for (let pi = 0; pi < element.ListTitle.Instances.length; pi++) {
                element.ListTitle.Instances[pi].StringValue = 
                element.ListTitle.Instances[pi].StringValue ||
                (element.ListTitle.Instances[pi].ValueType === V2ParameterValueType.ValueSet &&
                element.ListTitle.Instances[pi].SelectedValue?.Name &&
                !element.ListTitle.Instances[pi].SelectedValue?.Id
                  ? element.ListTitle.Instances[pi].SelectedValue?.Name
                  : '');
                
                if (!element.ListTitle.Instances[pi].SelectedValue?.Id) {
                  element.ListTitle.Instances[pi].SelectedValue = null;
                }

                // for filters section only!
                element.ListTitle.Instances[pi].Id = element.ListTitle.Instances[pi].TemplateId;

                if (element.ListTitle.Instances[pi].ValueType === V2ParameterValueType.Record) {
                  foreachRecursive(a, el_to_find, element.ListTitle.Instances[pi].RecordFields);
                }
            }
        }
      },
      undefined,
      instance_container
    );

  return res;
}

export function createEmptyFromInstance(source_insts: ParameterInstance, id_value: number = 0): ParameterInstance {
  const empty_from_instance = function(el: ParameterInstance) {
    const new_instance = {
      TemplateId: el.TemplateId,
      Unremovable: true,
      ValueType: el.ValueType,
      StringValue: initialStringValue(el),
      NumberValue: initialNumberValue(el),
      DateValue: initialDateValue(el),
      BoolValue: initialBoolValue(el),
      ValueSet: el.ValueSet,
      SelectedValue: null,
      ValueDisplayType: V2FieldValueDisplayType.Inline,
      Name: el.Name,
      Id: id_value,
      Round: 2,
      RecordAxisType: el.RecordAxisType,
      RecordFields:
      el.RecordFields && el.ValueType === V2ParameterValueType.Record ? mapRecursive(empty_from_container, el, el.RecordFields)
      : [],
    } as ParameterInstance;

    return new_instance;
  };

  const empty_from_container = function(element: ParameterInstanceContainer): ParameterInstanceContainer {
    if (!element) return {} as ParameterInstanceContainer;

    if (element.Type === ParameterInstanceContainerType.SingleInstance && element.Instance) {
      const newElement = {
        Type: ParameterInstanceContainerType.SingleInstance,
        Instance: empty_from_instance(element.Instance)
      } as ParameterInstanceContainer;

      return newElement;
    } else if (element.Type === ParameterInstanceContainerType.List && element.ListTitle) {
      const first_i = element.ListTitle.Instances[0];
      
      const newElement = {
        Type: ParameterInstanceContainerType.List,
        Instance: null,
        ListTitle: {
          Id: element.ListTitle.Id,
          Name: element.ListTitle.Name,
          Instances: [
            empty_from_instance(first_i)
          ],
          Unremovable: true
        } as ParameterListTitle
      }

      return newElement;
    }
    return {} as ParameterInstanceContainer
  };
  return empty_from_instance(source_insts);
}

export function mapStorageItemInstanceToParameterInstance(
  instance_source: StorageItemNameInstance[]
): ParameterInstanceContainer[] {
    const res = mapRecursive(
      function a(
        element: StorageItemNameInstance,
        el_to_find: any
      ): any | undefined {
        if (!element) return undefined;

        if (element.Descriptor === StorageItemNameInstanceDescriptor.Simple) {
          const typed_el = (element as StorageItemNameInstanceSimple);
          const newElement = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: typed_el.Template.Id,
              Name: typed_el.Template.Name,
              ValueDisplayType: typed_el.ValueDisplayType,
              ValueType: V2ParameterValueType.String,
              StringValue: typed_el.Value
            } as ParameterInstance
          } as ParameterInstanceContainer;

          // reassign
          return newElement;
        } else if (element.Descriptor === StorageItemNameInstanceDescriptor.Record) {

          const typed_el = (element as StorageItemNameInstanceRecord);
          const newElement = {
            Type: ParameterInstanceContainerType.SingleInstance,
            Instance: {
              TemplateId: typed_el.Template.Id,
              Name: typed_el.Template.Name,
              ValueType: V2ParameterValueType.Record,
              RecordFields: mapRecursive(a, el_to_find, typed_el.RecordFields),
              RecordAxisType: typed_el.RecordAxisType
            } as ParameterInstance
          } as ParameterInstanceContainer;
          
          return newElement;
        } else if (element.Descriptor === StorageItemNameInstanceDescriptor.Title) {
          const typed_el = (element as StorageItemNameInstanceTitle);
          const mapTitleInstance = (inst: StorageItemNameInstance): ParameterInstance => {
            if (inst.Descriptor === StorageItemNameInstanceDescriptor.Simple) {
              const si = inst as StorageItemNameInstanceSimple;
              return {
                TemplateId: si.Template.Id,
                Name: si.Template.Name,
                ValueDisplayType: si.ValueDisplayType,
                ValueType: V2ParameterValueType.String,
                StringValue: si.Value,
                Unremovable: false,
                RecordFields: [],
                Id: si.Id,
                BoolValue: null,
                NumberValue: null,
                DateValue: null,
                ValueSet: null,
                SelectedValue: null,
              } as ParameterInstance;
            }
            if (inst.Descriptor === StorageItemNameInstanceDescriptor.Record) {
              const ri = inst as StorageItemNameInstanceRecord;
              return {
                TemplateId: ri.Template.Id,
                Name: ri.Template.Name,
                ValueDisplayType: V2FieldValueDisplayType.Inline,
                ValueType: V2ParameterValueType.Record,
                RecordAxisType: ri.RecordAxisType,
                RecordFields: mapRecursive(a, el_to_find, ri.RecordFields),
                Unremovable: false,
                Id: ri.Id,
                StringValue: null,
                BoolValue: null,
                NumberValue: null,
                DateValue: null,
                ValueSet: null,
                SelectedValue: null,
              } as ParameterInstance;
            }
            // Title nested in Title: type system can't represent this as ParameterInstance, return empty string fallback
            return {
              TemplateId: inst.Template.Id,
              Name: inst.Template.Name,
              ValueDisplayType: V2FieldValueDisplayType.Inline,
              ValueType: V2ParameterValueType.String,
              StringValue: '',
              Unremovable: false,
              RecordFields: [],
              Id: inst.Id,
              BoolValue: null,
              NumberValue: null,
              DateValue: null,
              ValueSet: null,
              SelectedValue: null,
            } as ParameterInstance;
          };
          const newElement = {
            Type: ParameterInstanceContainerType.List,
            ListTitle: {
              Id: typed_el.Id,
              Name: typed_el.Template.Name,
              Instances: typed_el.Instances && typed_el.Instances.length
                ? typed_el.Instances.map(mapTitleInstance)
                : [
                  {
                    TemplateId: typed_el.Template.Id,
                    Name: typed_el.Template.Name,
                    ValueDisplayType: V2FieldValueDisplayType.Inline,
                    ValueType: V2ParameterValueType.String,
                    StringValue: '',
                    Unremovable: false,
                    RecordFields: [],
                    Id: 0,
                    BoolValue: null,
                    NumberValue: null,
                    DateValue: null,
                    ValueSet: null,
                    SelectedValue: null,
                  } as ParameterInstance
                ],
              Unremovable: true
            } as ParameterListTitle
          } as ParameterInstanceContainer;
          return newElement;
        }
        return undefined;
      },
      undefined,
      instance_source
    );
  return res;
}

/** initial primitive value methods */
function initialStringValue(el: ParameterInstanceCreateContainer | ParameterInstance) {
  switch (el.ValueType) {
    case V2ParameterValueType.String:
      return "";
    default:
      return null;
  }
}

function initialNumberValue(el: ParameterInstanceCreateContainer | ParameterInstance) {
  switch (el.ValueType) {
    case V2ParameterValueType.Int:
    case V2ParameterValueType.Double:
      return 0;
    default:
      return null;
  }
}

function initialBoolValue(el: ParameterInstanceCreateContainer | ParameterInstance) {
  switch (el.ValueType) {
    case V2ParameterValueType.Bool:
      return false;
    default:
      return null;
  }
}

function initialDateValue(el: ParameterInstanceCreateContainer | ParameterInstance) {
  switch (el.ValueType) {
    case V2ParameterValueType.Date:
      return new Date().toISOString();
    default:
      return null;
  }
}

export function getSpecificTemplateFromContainer(tid: number, model: ParameterInstanceContainer[]): ParameterInstanceContainer {
  return findRecursive(
      function a(
        element: ParameterInstanceContainer,
        el_to_find: any
      ): any | undefined {
        if (!element) return undefined;
        if (
          element.Type === ParameterInstanceContainerType.SingleInstance &&
          element.Instance
        ) {
          if (
            tid == element.Instance?.TemplateId
          ) {
            return element;
          }
          if (element.Instance.ValueType === V2ParameterValueType.Record) {
            const found_el = findRecursive(
              a,
              el_to_find,
              element.Instance.RecordFields
            );
            if (found_el) {
              return found_el;
            }
          }
        } else if (
          element.Type === ParameterInstanceContainerType.List &&
          element.ListTitle
        ) {
          for (let pi = 0; pi < element.ListTitle.Instances.length; pi++) {
            const el = element.ListTitle.Instances[pi];
            if (tid == el.TemplateId) {
              return element;
            }
            if (el.ValueType === V2ParameterValueType.Record) {
              const found_el = findRecursive(a, el_to_find, el.RecordFields);
              if (found_el) {
                return found_el;
              }
            }
          }
        }

        return undefined;
      },
      undefined,
      model
    );
}

export function mapCreateContainerToInstance(
  item: ParameterInstanceCreateContainer,
  ignoreLists = false
): ParameterInstanceContainer[] {

  let id_value = 1;
  const res = mapRecursive(
    function a(el: ParameterInstanceCreateContainer, parent: any) {
      if (!el.IsList || ignoreLists) {
        const new_el = {
          Type: ParameterInstanceContainerType.SingleInstance,
          Instance: {
            TemplateId: el.Template.Id,
            Unremovable: true,
            ValueType: el.ValueType,
            StringValue: initialStringValue(el),
            NumberValue: initialNumberValue(el),
            DateValue: initialDateValue(el),
            BoolValue: initialBoolValue(el),
            ValueSet: el.ValueSet,
            SelectedValue: null,
            ValueDisplayType: V2FieldValueDisplayType.Inline,
            Name: el.Template.Name,
            Id: id_value,
            Round: 2,
            RecordAxisType: el.RecordAxisType,
            RecordFields:
              el.RecordFields && el.ValueType === V2ParameterValueType.Record
                ? mapRecursive(a, el, el.RecordFields)
                : [],
          } as ParameterInstance,
          ListTitle: null,
        } as ParameterInstanceContainer;

        id_value++;
        return new_el;
      } else {
        const new_el = {
          Type: ParameterInstanceContainerType.List,
          Instance: null,
          ListTitle: {
            Id: id_value,
            Name: el.Template.Name,
            Unremovable: true,
            Instances: [
              {
                TemplateId: el.Template.Id,
                Unremovable: true,
                ValueType: el.ValueType,
                StringValue: initialStringValue(el),
                NumberValue: initialNumberValue(el),
                DateValue: initialDateValue(el),
                BoolValue: initialBoolValue(el),
                ValueSet: el.ValueSet,
                SelectedValue: null,
                ValueDisplayType: V2FieldValueDisplayType.Inline,
                Name: el.Template.Name,
                Id: id_value+1,
                Round: 2,
                RecordAxisType: el.RecordAxisType,
                RecordFields:
                  el.RecordFields &&
                  el.ValueType === V2ParameterValueType.Record
                    ? mapRecursive(a, el, el.RecordFields)
                    : [],
              } as ParameterInstance,
            ],
          },
        } as ParameterInstanceContainer;

        id_value += 2;
        return new_el;
      }
    },
    undefined,
    [item]
  );

  return res;
}

// other helpers
export function isNumeric(str: string) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseInt(str))
  ); // ...and ensure strings of whitespace fail
}

export function isNumericFloat(str: string) {
  if (typeof str != "string") return false; // we only process strings!
  return (
    !isNaN(+str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str.replace(',', '.')))
  ); // ...and ensure strings of whitespace fail
}
